import api from "@/services/api/dashboard";

function formatSighting(sighting) {
    return sighting;
}

const state = {
    isLoading: false,
    items: [],
    searchQuery: "",
    searchDate: null,
    searchSpecies: [],
    searchBehaviour: [],
    searchSightingType: [],
    searchOptions: {
        page: 1,
        itemsPerPage: -1,
        sortBy: ["sightingTime"],
        sortDesc: [true],
        multiSort: false,
    },
    total: 0,
};

const getters = {
    loading: (state) => state.isLoading,
    items: (state) => state.items,
    searchQuery: (state) => state.searchQuery,
    searchDate: (state) => state.searchDate,
    searchSpecies: (state) => state.searchSpecies,
    searchBehaviour: (state) => state.searchBehaviour,
    searchSightingType: (state) => state.searchSightingType,
    searchOptions: (state) => state.searchOptions,
    total: (state) => state.items.length,
};

const actions = {
    async search(
        { commit },
        { query, date, species, behaviour, sightingType, page, itemsPerPage, sortBy, sortDesc }
    ) {
        commit("loading", { isLoading: true });
        let originalQuery = query;
        let startDate;
        let endDate;

        if (date != null && date.length === 1) query = query + " " + date;
        else if (date != null && date.length > 1) {
            if (date[0] > date[1]) {
                startDate = date[1];
                endDate = date[0];
            }
            else if (date[0] < date[1]) {
                startDate = date[0];
                endDate = date[1];
            }
        }

        const result = await api.search({
            query,
            startDate,
            endDate,
            species,
            page,
            itemsPerPage,
            sortBy,
            sortDesc,
        });
        commit("loaded", {
            items: result.data,
            searchQuery: originalQuery,
            searchDate: date,
            searchSpecies: species,
            searchBehaviour: behaviour,
            searchSightingType: sightingType,
            searchOptions: { page, itemsPerPage, sortBy, sortDesc },
            total: result.total,
        });
        commit("loading", { isLoading: false });
    },
    async reload({ dispatch, state }) {
        dispatch("search", {
            query: state.searchQuery,
            date: state.searchDate,
            species: state.searchSpecies,
            behaviour: state.searchBehaviour,
            sightingType: state.searchSightingType,
            ...state.searchOptions,
        });
    },
};

const mutations = {
    loading(state, { isLoading }) {
        state.isLoading = isLoading;
    },
    loaded(state, { items, searchQuery, searchDate, searchSpecies, searchBehaviour, searchSightingType, searchOptions, total }) {
        state.searchQuery = searchQuery;
        state.searchDate = searchDate;
        state.searchSpecies = searchSpecies;
        state.searchBehaviour = searchBehaviour;
        state.searchSightingType = searchSightingType;
        state.searchOptions = { ...searchOptions };
        state.total = total;
        state.items = items.map((i) => formatSighting(i));
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
